import { collection, onSnapshot, doc, updateDoc, deleteDoc, query, where, getDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useState, useEffect } from "react";
import { auth } from "../utils/fipresConfig";
import { database } from "../utils/fipresConfig";
import Note from "../components/note/note";
import NoteForm from "../components/note/noteForm";
import "../style/notes.css";

export default function Notes({ isAdminView }) {
  const [user, loading] = useAuthState(auth);
  const [notes, setNotes] = useState([]);
  const [editingNote, setEditingNote] = useState(null);
  const [editText, setEditText] = useState("");
  const [name, setName] = useState(""); // To store the name fetched from users collection
  const [loadingName, setLoadingName] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [message, setMessage] = useState(""); // For handling messages

  useEffect(() => {
    if (user) {
      const fetchUserName = async () => {
        const userDoc = await getDoc(doc(database, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setName(userData.name); // Set the name from the users collection
          setIsAdmin(userData.isAdmin === true);
        }
        setLoadingName(false);
      };
      fetchUserName();

      const notesRef = collection(database, "notes");
      const q = isAdminView ? notesRef : query(notesRef, where("userId", "==", user.uid));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const notesData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        // Update the notes with the user's name
        const updatedNotes = notesData.map(note => ({
          ...note,
            // Update the name field in the note with the user's name
        }));
        setNotes(updatedNotes);
      });
      return () => unsubscribe();
    }
  }, [user, isAdminView, name]); // Ensure it updates when the user's name changes

  const handleEdit = (note) => {
    if (isAdmin || note.userId === user.uid) {
      setEditingNote(note);
      setEditText(note.text);
    } else {
      setMessage("You can only edit your own notes.");
    }
  };

  const handleSave = async () => {
    if (editText.trim() === "") {
      setMessage("Note cannot be empty.");
      return;
    }
    const noteRef = doc(database, "notes", editingNote.id);
    // Update the note text and name fields
    await updateDoc(noteRef, { text: editText, name: name });
    setEditingNote(null);
    setEditText("");
    setMessage("Note saved successfully.");
  };

  const handleDelete = async (noteId) => {
    if (isAdmin || notes.find(note => note.id === noteId).userId === user.uid) {
      const noteRef = doc(database, "notes", noteId);
      await deleteDoc(noteRef);
      setMessage("Note deleted successfully.");
    } else {
      setMessage("You can only delete your own notes.");
    }
  };

  return (
    <div className="mmmmm">
      <div className="notes-container">
        {!isAdminView && (
          <div className="notes-pragraph__content">
            {loading || loadingName ? (
              <span className="notes-pragraph__content--title">Loading...</span>
            ) : (
              <p className="notes-pragraph__content--title">
                Welcome, <span className="title-name">{name}</span>
              </p>
            )}
            <p className="notes-pragraph__content--main">
              I am very happy to have you here and hope you find the materials useful and interesting.
            </p>
            <p className="notes-pragraph__content--text">
              "If you have any feedback, feel free to share it."
            </p>
          </div>
        )}
        {!isAdminView && <NoteForm className="notes__content" userId={user?.uid} />}
      </div>
      <div >
        <h2 className="title_notes"> Your notes:</h2>
        <div className="all_notes">
          {notes.map((note) => (
            <Note
              key={note.id}
              text={note.text}
              name={note.name}  // Ensure the name field is consistent with users
              onEdit={() => handleEdit(note)}
              onDelete={() => handleDelete(note.id)}
              isEditing={editingNote?.id === note.id}
              editText={editText}
              setEditText={setEditText}
              handleSave={handleSave}
              canEdit={isAdmin || note.userId === user.uid}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
